import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';
import {PortalServiceUpdater} from '../../form/model/portal.service.updater';

import * as qs from 'querystring';

@Injectable()
export class VnaPortalService implements PortalServiceUpdater{

    constructor(private api: ApiService) { }

    findPortalServices(pkPortal: number) : Observable<any> {
        return this.api.get('vna/portal/' + pkPortal + '/service-config');
    }

    findMergedPortalService(pkPortal: number, pkService: number): Observable<any> {
        return this.api.get('vna/portal/' + pkPortal + '/service/' + pkService, { 'merged' : 1 });
    }

    getTestService(pkPortal: number, pkService: number, data: Object): Observable<any> {
        let extra = {  use_cache: data['use_cache'] };
        let params: {};
        delete data['use_cache'];

        let queryStr = qs.stringify(data);

        for(let key in extra){
            let keyValue = new String('extra[' + key + ']');
            queryStr = queryStr.toString() + '&' + encodeURIComponent(keyValue.toString()) + '=' + encodeURIComponent(extra[key]);
        }

        return this.api.get('vna/portal/' + pkPortal + '/service/' + pkService + '/test?' + queryStr.toString());
    }

    getExternalCallbacks(criteria: Object): Observable<any> {
        return this.api.get('vna/external-callback', { 'portal_pk' : criteria['portal_pk'], 'service_pk' : criteria['service_pk'] });
    }

    saveExternalCallback(data: Object): Observable<any> {
        return this.api.post('vna/external-callback', data);
    }

    removeExternalCallback(pk: number): Observable<any> {
        return this.api.remove('vna/external-callback', pk);
    }

    updateExternalCallback(pk:number,data:any){
        return this.api.put('vna/external-callback',pk,data);
    }

    savePortalService(criteria: Object, configPart: string, aliasSrv: string, data: Object): Observable<any> {
        const url = 'vna/service/' + criteria['service_pk'] + '/portal-config/' + criteria['portal_pk'] + '?segment=' + configPart + '&alias_srv=' + aliasSrv;
        return this.api.post(url, data)
    }

    getPortalPendingServices(pkPortal: number): Observable<any> {
        return this.api.get('vna/portal/' + pkPortal + '/pending-service');
    }

    addServiceToPortal(pkPortal: number, data: Object): Observable<any> {
        return this.api.post('vna/portal/' + pkPortal + '/service', data);
    }

    removeServiceFromPortal(pkPortal: number, pkService: number): Observable<any> {
        return this.api.customRemove('vna/portal/' + pkPortal + '/service/' + pkService);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/services/vna-portal.service.ts